import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { PatientAppIframeId } from '@shared/models/enums/patient-app-iframe-id.enum';
import { PatientAppUrlBuilderService } from '@modules/patient/services/patient-app-url-builder.service';
import { PatientQuery } from '@modules/patient/state/patient-query';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Independent container for the PatientApp Inline iframe mode.
 * Encapsulates URL building, iframe ID, and conflict state for the inline
 * patient form display (patient creation/viewing in main flow).
 *
 * Note: initializePatientAppStreams$ and patientPopupCommandHandler$ are
 * subscribed by the parent PatientComponent — not duplicated here.
 */
@Component({
	selector: 'rx-patient-app-inline',
	templateUrl: './patient-app-inline.component.html',
	styleUrls: ['./patient-app-inline.component.scss']
})
export class PatientAppInlineComponent extends BaseDestroyableComponent implements OnInit {
	readonly patientAppId = PatientAppIframeId;

	inlinePatientAppUrl$: Observable<SafeResourceUrl>;
	readonly isPatientInConflict$: Observable<boolean | null> = this.patientQuery.isPatientInConflict$;
	readonly isResizePatientAppDialog$: Observable<boolean | null> = this.patientQuery.isPatientInConflict$;

	constructor(
		private readonly sanitizer: DomSanitizer,
		private readonly patientAppUrlBuilderService: PatientAppUrlBuilderService,
		private readonly patientQuery: PatientQuery
	) {
		super();
	}

	ngOnInit(): void {
		this.inlinePatientAppUrl$ = this.patientAppUrlBuilderService
			.getInlinePatientAppUrl()
			.pipe(map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url)));
	}
}
